import axios from 'axios';



const BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === "development" ? "http://localhost:4346" : "");


// export const voiceTranslate = async (formData, isAudio = false, language = 'en') => {
//     try { 
//         if (isAudio && formData instanceof FormData) {
//             const response = await axios.post(
//                 `${BASE_URL}/api/indicasr/auto-detection-indic-transcribe`,
//                 formData,
//                 {
//                     headers: {
//                         'ngrok-skip-browser-warning': 'true'
//                     }
//                 }
//             );
//             console.log("Voice Translate Response:", response.data);
//             // Extract ASR text from response
//             return {
//                 transcript: response.data?.translation?.asr || "",
//                 language: response.data?.language || language,
//                 ...response.data
//             };
//         } else if (!isAudio) {
//             console.warn("voiceTranslate: isAudio must be true for FormData");
//             return { error: "Invalid audio data" };
//         } else {
//             console.warn("voiceTranslate: payload is not FormData");
//             return { error: "Payload must be FormData" };
//         }
//     } catch (error) {
//         console.error("Voice Translate API Error:", error.response?.data || error.message);
//         return { error: error.response?.data?.error || error.message };
//     }
// };

// export const englishAsr = async (formData) => {
//     try {
//         if (formData instanceof FormData) {
//             const response = await axios.post(
//                 `${BASE_URL}/api/collect/transcribe`,
//                 formData,
//                 {
//                     headers: {
//                         'Content-Type': 'multipart/form-data',
//                         'ngrok-skip-browser-warning': 'true'
//                     }
//                 }
//             );
//             console.log("ASR Response:", response.data);
//             return response.data;
//         } else {
//             console.warn("englishAsr: payload is not FormData");
//             return { error: "Payload must be FormData" };
//         }
//     } catch (error) {
//         console.error("ASR API Error:", error.response?.data || error.message);
//         return { error: error.response?.data?.error || error.message };
//     }
// };

export const voiceTranslate = async (formData, isAudio = false) => {
    try {
        if (isAudio && formData instanceof FormData) {
            const response = await axios.post(
                `${BASE_URL}/api/collect/translate`,
                formData,
                {
                    headers: {
                        'ngrok-skip-browser-warning': 'true'
                    }
                }
            );
            console.log("Voice Translate Response:", response.data);
            return response.data;
        } else if (!isAudio) {
            console.warn("voiceTranslate: isAudio must be true for FormData");
            return { error: "Invalid audio data" };
        } else {
            console.warn("voiceTranslate: payload is not FormData");
            return { error: "Payload must be FormData" };
        }
    } catch (error) {
        console.error("Voice Translate API Error:", error.response?.data || error.message);
        return { error: error.response?.data?.error || error.message };
    }
};

export const OtherLanguageAsr = async (formData) => {
    try {
        if (formData instanceof FormData) {
            const response = await axios.post(
                `${BASE_URL}/api/indicasr/indic-transcribe`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'ngrok-skip-browser-warning': 'true'
                    }
                }
            );
            console.log("Other Language ASR Response:", response.data);
            return response.data;
        } else {
            console.warn("OtherLanguageAsr: payload is not FormData");
            return { error: "Payload must be FormData" };
        }
    } catch (error) {
        console.error("Other Language ASR API Error:", error.response?.data || error.message);
        return { error: error.response?.data?.error || error.message };
    }
}

export const translateVoice = async (formData, selectedLanguage) => {
    try {
        if (selectedLanguage === 'english' || selectedLanguage === 'en') {
            return await voiceTranslate(formData, true, 'en');
        } else {
            return await OtherLanguageAsr(formData);
        }
    } catch (error) {
        console.error("Translate Voice Error:", error.message);
        return { error: error.message };
    }
};
export const translateBaani = async (data) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/banni-translate`,
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'ngrok-skip-browser-warning': 'true'
                }
            }
        );
        console.log("Baani Translate Response:", response.data);
        return response.data;
    } catch (error) {
        console.error("Baani Translate API Error:", error.response?.data || error.message);
        return { error: error.response?.data?.error || error.message };
    }
}


export const ttsBani = async (data) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/api/banni/tts`,
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'ngrok-skip-browser-warning': 'true'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Baani TTS error:", error.response?.data || error.message);
        return { error: error.response?.data?.error || error.message };
    }
}

// ---------------- SARVAM AI BACKEND PROXY APIS ----------------

export const asrSarvam = async (audioBlob, languageCode) => {
    try {
        const formData = new FormData();
        formData.append('file', audioBlob, 'audio.wav');
        formData.append('lang', languageCode);

        const response = await axios.post(
            `${BASE_URL}/api/sarvam/sarvam-asr`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'ngrok-skip-browser-warning': 'true'
                }
            }
        );
        return response.data['transcript'];
    } catch (error) {
        console.error("Sarvam ASR error:", error.response?.data || error.message);
        return { error: error.response?.data?.error || error.message };
    }
};
export const translateSarvam = async (text, targetLanguage, sourceLanguage = null) => {
    try {
        const formData = new FormData();
        formData.append('text', text);
        formData.append('target_lang', targetLanguage);
        if (sourceLanguage) {
            formData.append('source_lang', sourceLanguage);
        }

        const response = await axios.post(
            `${BASE_URL}/api/sarvam/sarvam-translate`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'ngrok-skip-browser-warning': 'true'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Sarvam translate error:", error.response?.data || error.message);
        return { error: error.response?.data?.error || error.message };
    }
};
export const ttsSarvam = async (text, languageCode) => {
    try {
        const formData = new FormData();
        formData.append('text', text);
        formData.append('lang', languageCode);

        const response = await axios.post(
            `${BASE_URL}/api/sarvam/sarvam-tts-base64`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'ngrok-skip-browser-warning': 'true'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Sarvam TTS error:", error.response?.data || error.message);
        return { error: error.response?.data?.error || error.message };
    }
};
export const masterOrchestration = async (data) => {
    try {
        const response = await axios.post(
            `http://172.16.16.111:8097/api/master_orchestration`,
            data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'ngrok-skip-browser-warning': 'true'
                }
            }
        );
        return response.data;
    } catch (error) {
        console.error("Master Orchestration Error:", error.response?.data || error.message);
        return { error: error.response?.data?.error || error.message };
    }
};
